import { PageEvents } from "Component/Page/PageEvent";

export const APPEAR_PAGE = 'APPEAR_PAGE';

export const pageAppear = (page: PageEvents) => ({
    type: APPEAR_PAGE,
    payload: {
        page,
    }
});